import React, {
  useEffect,
  useState,
} from "react";

import {
  useNavigate,
} from "react-router-dom";

import {
  FaHeart,
  FaRegHeart,
} from "react-icons/fa";

import "flag-icons/css/flag-icons.min.css";

import {
  useCommunityFavorites,
} from "./CommunityFavorites";

import {
  useFavorites,
} from "./FavoritesContext";

import "./FlagStyles.css";
import "./CommunityFavorite.css";

function CommunityConnect({
  countries = [],
  frequentlyVisited = [],
  collapsed = false,
  /* Optional: renders a "See all N" tile as the grid's last
     cell. { count, expanded, onToggle } no heart, no nav. */
  seeAllTile = null,
}) {
  const navigate = useNavigate();

  const {
    isCommunitySaved,
    toggleCommunityFavorite,
    isSignedIn,
  } = useCommunityFavorites();

  /*
   * This is the SAME prompt system business hearts use.
   */
  const {
    requestSignInPrompt,
  } = useFavorites();

  const [
    pendingCommunity,
    setPendingCommunity,
  ] = useState(null);

  /*
   * After FavoritesContext finishes email verification,
   * the shared session becomes signed in. Save the exact
   * community the visitor originally hearted.
   */
  useEffect(() => {
    if (
      !isSignedIn ||
      !pendingCommunity
    ) {
      return;
    }

    toggleCommunityFavorite(
      pendingCommunity
    );

    setPendingCommunity(null);
  }, [
    isSignedIn,
    pendingCommunity,
    toggleCommunityFavorite,
  ]);

  const handleFavorite = (
    event,
    country
  ) => {
    event.preventDefault();
    event.stopPropagation();

    if (!isSignedIn) {
      setPendingCommunity(country);

      requestSignInPrompt({
        kind: "community",
        name:
          country.people ||
          "this community",
        onCancel: () =>
          setPendingCommunity(null),
      });

      return;
    }

    toggleCommunityFavorite(
      country
    );
  };

  const renderButton = (
    country,
    index
  ) => {
    const saved =
      isCommunitySaved(country);

    return (
      <div
        key={`${country.people}-${index}`}
        className={`community-favorite-wrap ${
          collapsed
            ? "community-favorite-wrap--collapsed"
            : "community-favorite-wrap--full"
        }`}
      >
        <button
          type="button"
          className={`flag-button ${
            collapsed
              ? "icon-only"
              : ""
          }`}
          title={country.people}
          aria-label={`Open ${country.people} community`}
          onClick={() => {
            if (country.url) {
              navigate(country.url);
            }
          }}
        >
          <span
            className={`fi fi-${country.flag} flag-icon`}
            aria-hidden="true"
          />

          {!collapsed && (
            <span className="flag-name">
              {country.people}
            </span>
          )}
        </button>

        <button
          type="button"
          className={`community-favorite-btn ${
            saved
              ? "is-saved"
              : ""
          }`}
          onClick={(event) =>
            handleFavorite(
              event,
              country
            )
          }
          aria-pressed={saved}
          aria-label={
            saved
              ? `Remove ${country.people} from favorite communities`
              : `Save ${country.people} as a favorite community`
          }
          title={
            saved
              ? "Remove favorite community"
              : "Favorite this community"
          }
        >
          {saved ? (
            <FaHeart
              aria-hidden="true"
            />
          ) : (
            <FaRegHeart
              aria-hidden="true"
            />
          )}
        </button>
      </div>
    );
  };

  return (
    <div
      className={`left-column ${
        collapsed
          ? "is-collapsed"
          : "is-expanded"
      }`}
    >
      <div>
        {!collapsed && (
          <h5 className="section-heading margin-top">
            
          </h5>
        )}

        <div className="frequent-list">
          {frequentlyVisited.map(
            renderButton
          )}

          {seeAllTile && !collapsed && (
            <div className="community-favorite-wrap community-favorite-wrap--full">
              <button
                type="button"
                className="flag-button community-see-all"
                onClick={seeAllTile.onToggle}
                aria-expanded={!!seeAllTile.expanded}
              >
                <span className="community-see-all__icon" aria-hidden="true">
                  {seeAllTile.expanded ? "−" : "＋"}
                </span>

                <span className="flag-name">
                  {seeAllTile.expanded
                    ? "Show less"
                    : `See all ${seeAllTile.count}`}
                </span>
              </button>
            </div>
          )}
        </div>
      </div>

      <hr className="divider" />
    </div>
  );
}

export default CommunityConnect;
